// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function FinalizedBadContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                (rowContractData.comboStatus === 'f'  && rowContractData.inputMissingRollup > 0 )
                &&
                <div>
                    <Tooltip
                        enterDelay={1000}
                        title="FinalizedBadContractAvatar"
                    >
                    <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}>f
                    </Avatar>
                    </Tooltip>
                </div>}
        </Box>

    )

}
